import React from "react";
import PageNotFound from "../PageNotFound";
import Container from "../../components/Container";
import Layout from "../../components/Layout";

const isProdReady = (Component, env = ["local", "dev", "stage"]) => props => {
  const isProductionReady = env.includes(process.env.REACT_APP_ENV);
  if (isProductionReady) {
    return <Component {...props} />;
  }
  return (
    <Layout>
      <Container>
        <PageNotFound />
      </Container>
    </Layout>
  );
};

export default isProdReady;
